import React, {useState, useEffect} from "react"
import {
    DndContext,
    PointerSensor,
    useSensor,
    useSensors,
    closestCenter,
} from "@dnd-kit/core"
import PropTypes from "prop-types"
import {nanoid} from "nanoid"
import WeltBoardLayer from "./WeltBoardLayer"

const BOARD_ID = "drop-board"
const ITEM_SIZE = 64;

const WidgetWeltBoard = ({value = [], onValueChange, widget, triggerAction}) => {
    const [items, setItems] = useState([])
    useEffect(() => {
        if (JSON.stringify(value) !== JSON.stringify(items)) {
            setItems(value || [])
        }
    }, [value])

    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 5,
            },
        }),
    )

    const handleDragEnd = (event) => {
        const {active, over} = event

        const boardEl = document.getElementById(BOARD_ID)

        if (!over || !boardEl) {
            return
        }

        const boardRect = boardEl.getBoundingClientRect()
        let newX = 0,
            newY = 0

        if (active.rect.current?.translated) {
            newX =
                active.rect.current.translated.left -
                boardRect.left +
                boardEl.scrollLeft
            newY =
                active.rect.current.translated.top -
                boardRect.top +
                boardEl.scrollTop
        }

        newX = Math.max(0, Math.min(newX, boardRect.width - ITEM_SIZE))
        newY = Math.max(0, Math.min(newY, boardRect.height - ITEM_SIZE))

        let newItemsList = []

        if (active.data.current?.isCreator) {
            const type = active.data.current.type
            const newItem = {
                id: `${type}-${nanoid(6)}`,
                type,
                x: newX,
                y: newY,
            }
            newItemsList = [...items, newItem]
        } else {
            newItemsList = items.map((item) =>
                item.id === active.id ? {...item, x: newX, y: newY} : item,
            )
        }

        setItems(newItemsList)
        onValueChange?.(newItemsList)
    }

    return (
        <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}>
            <WeltBoardLayer items={items} widget={widget} triggerAction={triggerAction} />
        </DndContext>
    )
}

WidgetWeltBoard.propTypes = {
    value: PropTypes.array,
    onValueChange: PropTypes.func,
    widget: PropTypes.object,
}

export default WidgetWeltBoard
